import React, { Component, PropTypes } from 'react';
import { CircularProgress } from 'material-ui';
import { Units } from 'Css';

const css = oxygenCss({
  container: {
    textAlign: 'center',
    paddingTop: Units.base
  }
});

class Loader extends Component {
  render() {
    return (
      <div className={css.container}>
        <CircularProgress mode="indeterminate" />
      </div>
    );
  }
}

export default Loader;



// WEBPACK FOOTER //
// ./src/js/Cio/Loader.js